import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/views/index.vue'], resolve),
    },
    {
      path: '/sample',
      name: 'sample',
      component: resolve => require(['@/views/index.vue'], resolve),
    }
  ]
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js